import React, { useState, useEffect } from "react";

const ObjectionAlert = () => {
  const [isObjectionActive, setIsObjectionActive] = useState(false);

  useEffect(() => {
    const handleObjection = () => {
      setIsObjectionActive(true);
      setTimeout(() => setIsObjectionActive(false), 3000); // Hide after 3 seconds
    };

    window.addEventListener("objection-triggered", handleObjection);

    return () => {
      window.removeEventListener("objection-triggered", handleObjection);
    };
  }, []);

  if (!isObjectionActive) return null; 

  return (
    <div className="fixed top-0 left-0 w-full h-full bg-black bg-opacity-50 flex justify-center items-center z-50">
      <h1 className="text-white text-6xl font-bold animate-pulse">OBJECTION!</h1>
    </div>
  );
};

export default ObjectionAlert;
